import React, { useState } from "react";
import { API, apiClient as axios } from "../../lib/api";

export default function AuthPage({ onLogin }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    try {
      setError("");
      const res = await axios.post(`${API}/auth/login`, { email, password });
      onLogin(res.data.data.access_token, res.data.data.user, res.data.data.requires_password_change);
    } catch (err) {
      setError(err?.response?.data?.error || "Something went wrong");
    }
  };

  return (
    <div className="auth-card">
      <div className="auth-logo">
        <img src="/logo.webp" alt="Food Forward Ventures" />
      </div>
      <div className="brand">Food Forward Venture</div>
      <form onSubmit={submit} className="form">
        <input type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} autoComplete="email" required />
        <input type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} autoComplete="current-password" required />
        {error && <div className="error">{error}</div>}
        <button type="submit" className="primary-btn" data-testid="submit-button">Login</button>
      </form>
    </div>
  );
}


